<script>
  import { TRENDS_OTHER } from '../colors.js';
  import { assignTrendFills } from '../utils/assign-trend-fills.js';

  export let fillClass;
  export let holdoversClass;
  export let borderClass;
  export let netChanges;

  const rows = [
    0.5,
    39.62,
    78.74,
    117.86,
    156.98,
    196.1,
    235.22,
    274.34,
    313.46,
    352.59
  ];

  const columns = [
    { x: 22.5, start: 6, seats: [1, 2, 3, 4] },
    { x: 62.36, start: 4, seats: [5, 6, 7, 8, 9, 10] },
    { x: 102.22, start: 3, seats: [11, 12, 13, 14, 15, 16, 17] },
    { x: 142.08, start: 2, seats: [18, 19, 20, 21, 22, 23, 24, 25] },
    { x: 181.94, start: 1, seats: [26, 27, 28, 29, 30, 31] },
    { x: 221.79, start: 1, seats: [35, 36, 32, 33, 34] },
    { x: 261.65, start: 0, seats: [37, 38, 39, 40, 41] },
    { x: 301.51, start: 0, seats: [42, 43, 44, 45, 46] },
    { x: 341.37, start: 0, seats: [47, 48, 49, 50] },
    { x: 381.68, start: 0, seats: [51, 52, 53, 54] },
    { x: 421.54, start: 0, seats: [55, 56, 57, 58, 59] },
    { x: 461.4, start: 0, seats: [60, 61, 62, 63, 64] },
    { x: 501.26, start: 1, seats: [65, 66, 67, 68, 69] },
    { x: 541.12, start: 1, seats: [70, 71, 72, 73, 74, 75] },
    { x: 580.98, start: 2, seats: [76, 77, 78, 79, 80, 81, 82, 83] },
    { x: 620.84, start: 3, seats: [84, 85, 86, 87, 88, 89, 90] },
    { x: 660.69, start: 4, seats: [91, 92, 93, 94, 95, 96] },
    { x: 700.55, start: 6, seats: [97, 98, 99, 100] }
  ];

  const seats = columns.flatMap(({ x, start, seats }) =>
    seats.map((n, row) => ({
      n,
      x,
      y: rows[start + row]
    }))
  );

  $: seatLayout = assignTrendFills(
    seats,
    fillClass,
    holdoversClass,
    borderClass,
    netChanges,
    380,
    36.94
  );

  $: seatFills = seatLayout.fills;
  $: seatBorders = seatLayout.borders;
</script>

<div class="seat-chart seat-chart--senate">
  <svg
    id="senate-svg"
    class="seat-chart__svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="22.5 0 715 389.34"
    aria-hidden="true"
  >
    <line
      id="half-line"
      x1="380"
      y1="0.5"
      x2="380"
      y2="193.24"
    />

    <g id="senate-seats">
      {#each seats as seat, i}
        <rect
          id={`senate-seat-${i + 1}`}
          data-name={i + 1}
          class="{seatFills.get(seat.n)} {seatBorders.get(seat.n)} {holdoversClass(seat.n)}"
          style:fill={seatFills.get(seat.n) === 'other' ? TRENDS_OTHER : null}
          x={seat.x + (holdoversClass(seat.n) ? 0.2 : 2)}
          y={seat.y + (holdoversClass(seat.n) ? 0.2 : 2)}
          width={36.94 - (holdoversClass(seat.n) ? 0.4 : 4)}
          height={36.26 - (holdoversClass(seat.n) ? 0.4 : 4)}
        />
      {/each}
    </g>
  </svg>

  <div class="seat-chart__majority text-sm">
    <span>51 seats</span>
    <span>for a majority</span>
  </div>
</div>